<template>
  <div class="empty-state">
    <img class="empty-state-image" :src="image" />
    <h4 class="empty-state-title">{{ title }}</h4>
    <p class="empty-state-text">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    image: {
      type: String,
      required: true,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
};
</script>
